/* 🤖 this file was generated by svg-to-ts */
export const matIconBackpack: {
  name: 'backpack';
  data: string;
} = {
  name: 'backpack',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 4.14V2h-3v2h-4V2H7v2.14c-1.72.45-3 2-3 3.86v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.86-1.28-3.41-3-3.86zM18 20H6V8c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v12zm-1.5-8v4h-2v-2h-7v-2h9z"/></svg>`
};
